import React from "react";
import { useForm } from "features/shared/forms/hooks/useForm";
import ModalFooter from "features/shared/components/modal/ModalFooter";
import FormGroup from "features/shared/forms/components/FormGroup";
import FileInput from "features/shared/forms/components/FileInput";
import { fileUploadSubDialogValidations } from "./fileUploadSubDialogValidation";
import { useTranslation } from "react-i18next";
import { useTranslationWithPrefix } from "features/shared/hooks/useTranslationWithPrefix";

type Props = {
  onSubmit: (files: FileList) => void;
};

const FileUploadSubDialog = ({ onSubmit }: Props) => {
  // translations
  const tValidations = useTranslation("shared\\validations").t;
  const tLabels = useTranslationWithPrefix("shared\\components", "fileUploadSubDialog");

  // form hook
  const {
    getFormValue,
    errors,
    valideteForm,
    clearForm,
    bindUncontrolledField,
  } = useForm({
    initialValidations: fileUploadSubDialogValidations(tValidations),
  });

  // handlers
  const submitFormHandler = (e: React.FormEvent) => {
    e.preventDefault();

    if (valideteForm()) {
      let files = getFormValue<FileList>("uploadedFile");
      onSubmit(files);
      clearForm();
    }
  };

  // render
  return (
    <form onSubmit={submitFormHandler}>
      <div className="modal-body py-4">
        <FormGroup
          labelText={tLabels("fileUploadDialogFileLabel")}
          inputId="fileUploadDialogFile"
          validationError={errors["uploadedFile"]}
        >
          <FileInput
            id="fileUploadDialogFile"
            {...bindUncontrolledField("uploadedFile")}
          />
        </FormGroup>
      </div>
      <ModalFooter>
        <button type="submit" className="btn btn-primary">
          {tLabels("uploadFile")}
        </button>
      </ModalFooter>
    </form>
  );
};

export default FileUploadSubDialog;
